module.exports = __webpack_public_path__ + "static/mongo-bread-e6696af530315e58fc1671f7be9e1e7c.jpg";